module.exports = __webpack_public_path__ + "img/step4-c.3e864f1f.png";